import {
  PrinterConfigDto,
  PrintoutConfigDto,
  PrintoutSearchRequest,
  UpsertPrintoutConfigDto
} from 'ts-types/api.types';
import axios from './http';
import { CancelTokenSource } from 'axios';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/printout-config`;

export const getPrintoutsForDefaultMandate = (
    printoutSearchRequest: Partial<PrintoutSearchRequest>,
    source: CancelTokenSource): Promise<Array<PrintoutConfigDto>> => {

      return axios
          .post(`${apiUri}/search/default`, printoutSearchRequest,{cancelToken: source.token})
          .then(response => response.data);
    };

export const getPrintoutsForMandate = (
    printoutSearchRequest: Partial<PrintoutSearchRequest>,
    source: CancelTokenSource): Promise<Array<PrintoutConfigDto>> => {

      return axios
          .post(`${apiUri}/search`, printoutSearchRequest,{cancelToken: source.token})
          .then(response => response.data);
    };

export const getAllPrinters =
    (source: CancelTokenSource): Promise<Array<PrinterConfigDto>> => {

      return axios
          .get(`${baseUrl}/api/printers`, {cancelToken: source.token})
          .then(response => response.data);
    };

export const findPrintoutConfigById = (id: number, source: CancelTokenSource): Promise<UpsertPrintoutConfigDto> => {

  return axios
      .get(`${apiUri}/get/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const savePrintoutConfig = (
    upsertPrintoutConfigDto: Partial<UpsertPrintoutConfigDto>): Promise<PrintoutConfigDto> => {

  return axios
      .post(apiUri, upsertPrintoutConfigDto)
      .then(response => response.data);
};

export const editPrintoutConfig = (
    id: number,
    upsertPrintoutConfigDto: Partial<UpsertPrintoutConfigDto>): Promise<PrintoutConfigDto> => {

  return axios
      .put(`${apiUri}/${id}`, upsertPrintoutConfigDto)
      .then(response => response.data);
};

export const deletePrintoutConfig = (id: number, source: CancelTokenSource): Promise<string> => {

  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};
